var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.open
    ? _c(
        "aside",
        {
          staticClass: "wkb-assistant-popup",
          attrs: {
            role: "dialog",
            "aria-modal": "false",
            "aria-labelledby": "wkb-assistant-title",
          },
          on: {
            click: function ($event) {
              $event.stopPropagation()
            },
            mousedown: function ($event) {
              $event.stopPropagation()
            },
          },
        },
        [
          _c("header", { staticClass: "wkb-assistant-head" }, [
            _c("div", { staticClass: "wkb-assistant-head-row" }, [
              _c("h2", { attrs: { id: "wkb-assistant-title" } }, [
                _vm._v("Canvas assistant"),
              ]),
              _c(
                "button",
                {
                  staticClass: "wkb-assistant-close",
                  attrs: {
                    type: "button",
                    "aria-label": "Close",
                    disabled: _vm.executing,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("close")
                    },
                  },
                },
                [_vm._v(" × ")]
              ),
            ]),
            _c(
              "div",
              {
                staticClass: "wkb-assistant-tabs",
                attrs: { role: "tablist", "aria-label": "Assistant sections" },
              },
              [
                _c(
                  "button",
                  {
                    staticClass: "wkb-assistant-tab",
                    class: { "is-active": _vm.activeTab === "request" },
                    attrs: {
                      id: "wkb-assistant-tab-request",
                      type: "button",
                      role: "tab",
                      "aria-selected":
                        _vm.activeTab === "request" ? "true" : "false",
                      "aria-controls": "wkb-assistant-panel-request",
                      disabled: _vm.executing,
                    },
                    on: {
                      click: function ($event) {
                        _vm.activeTab = "request"
                      },
                    },
                  },
                  [_vm._v(" Request ")]
                ),
                _c(
                  "button",
                  {
                    staticClass: "wkb-assistant-tab",
                    class: { "is-active": _vm.activeTab === "actions" },
                    attrs: {
                      id: "wkb-assistant-tab-actions",
                      type: "button",
                      role: "tab",
                      "aria-selected":
                        _vm.activeTab === "actions" ? "true" : "false",
                      "aria-controls": "wkb-assistant-panel-actions",
                      disabled: _vm.executing,
                    },
                    on: {
                      click: function ($event) {
                        _vm.activeTab = "actions"
                      },
                    },
                  },
                  [_vm._v(" Actions ")]
                ),
              ]
            ),
            _vm.activeTab === "request" && !_vm.hasThread
              ? _c("p", { staticClass: "wkb-assistant-autocomplete-hint" }, [
                  _vm._v(" Suggestions appear as you type. Hover or use "),
                  _c("kbd", { staticClass: "wkb-assistant-kbd" }, [
                    _vm._v("↑"),
                  ]),
                  _c("kbd", { staticClass: "wkb-assistant-kbd" }, [
                    _vm._v("↓"),
                  ]),
                  _vm._v(
                    " to see the full name above the list for long labels. Press "
                  ),
                  _c("kbd", { staticClass: "wkb-assistant-kbd" }, [
                    _vm._v("Tab"),
                  ]),
                  _vm._v(" or "),
                  _c("kbd", { staticClass: "wkb-assistant-kbd" }, [
                    _vm._v("Enter"),
                  ]),
                  _vm._v(" to accept, "),
                  _c("kbd", { staticClass: "wkb-assistant-kbd" }, [
                    _vm._v("Esc"),
                  ]),
                  _vm._v(" to close. "),
                ])
              : _vm._e(),
            _vm.activeTab === "request" && !_vm.hasThread
              ? _c("p", { staticClass: "wkb-assistant-intro" }, [
                  _vm._v(
                    " Describe graph changes in plain language. The assistant builds a step-by-step plan, then runs those steps for you. "
                  ),
                ])
              : _c("p", { staticClass: "wkb-assistant-intro" }, [
                  _vm._v(
                    " What you can ask for on the Request tab. Type similar requests in your own words — this list does not run actions directly. "
                  ),
                ]),
          ]),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.activeTab === "request",
                  expression: "activeTab === 'request'",
                },
              ],
              ref: "messageScroll",
              staticClass: "wkb-assistant-body",
              attrs: {
                id: "wkb-assistant-panel-request",
                role: "tabpanel",
                "aria-labelledby": "wkb-assistant-tab-request",
              },
            },
            [
              !_vm.hasThread
                ? _c("div", { staticClass: "wkb-assistant-welcome" }, [
                    _c("p", { staticClass: "wkb-assistant-welcome-lead" }, [
                      _vm._v("You can ask things like:"),
                    ]),
                    _c(
                      "ul",
                      { staticClass: "wkb-assistant-examples" },
                      _vm._l(_vm.welcomeExamples, function (example, index) {
                        return _c("li", { key: `welcome-example-${index}` }, [
                          _vm._v(" " + _vm._s(example) + " "),
                        ])
                      }),
                      0
                    ),
                  ])
                : _c(
                    "div",
                    {
                      staticClass: "wkb-assistant-thread",
                      attrs: { role: "log", "aria-live": "polite" },
                    },
                    [
                      _vm._l(_vm.threadEntries, function (entry) {
                        return _c(
                          "div",
                          {
                            key: entry.id,
                            class: [
                              "wkb-assistant-message",
                              entry.role === "user"
                                ? "wkb-assistant-message--user"
                                : "wkb-assistant-message--assistant",
                              entry.isClarify
                                ? "wkb-assistant-message--clarify"
                                : "",
                              entry.isStepResult
                                ? "wkb-assistant-message--step-result"
                                : "",
                              entry.isStepError
                                ? "wkb-assistant-message--step-error"
                                : "",
                            ],
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "wkb-assistant-message-label" },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      entry.role === "user"
                                        ? "You"
                                        : entry.isStepError
                                        ? "Step failed"
                                        : entry.isStepResult
                                        ? "Step"
                                        : "Assistant"
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                            entry.isStepError && entry.stepLabel
                              ? _c(
                                  "p",
                                  {
                                    staticClass:
                                      "wkb-assistant-step-error-label",
                                  },
                                  [_vm._v(" " + _vm._s(entry.stepLabel) + " ")]
                                )
                              : _vm._e(),
                            _c("p", [_vm._v(_vm._s(entry.text))]),
                            entry.alternatives && entry.alternatives.length
                              ? _c(
                                  "div",
                                  { staticClass: "wkb-assistant-alt-options" },
                                  _vm._l(entry.alternatives, function (alt) {
                                    return _c(
                                      "button",
                                      {
                                        key: `alt-${entry.id}-${alt.index}`,
                                        staticClass: "wkb-assistant-alt-option",
                                        attrs: {
                                          type: "button",
                                          disabled:
                                            _vm.planning || _vm.executing,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onRunAlternative(
                                              alt.index
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v(" " + _vm._s(alt.label) + " ")]
                                    )
                                  }),
                                  0
                                )
                              : _vm._e(),
                            entry.isStepError && entry.resolution
                              ? _c(
                                  "p",
                                  {
                                    staticClass:
                                      "wkb-assistant-step-error-resolution",
                                  },
                                  [
                                    _c("strong", [_vm._v("What to do:")]),
                                    _vm._v(
                                      " " + _vm._s(entry.resolution) + " "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            entry.workflowLink
                              ? _c(
                                  "p",
                                  { staticClass: "wkb-assistant-workflow-cta" },
                                  [
                                    _c(
                                      "a",
                                      {
                                        staticClass:
                                          "wkb-assistant-workflow-link",
                                        attrs: {
                                          href: entry.workflowLink.href,
                                          target: "_blank",
                                          rel: "noopener noreferrer",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " Open " +
                                            _vm._s(entry.workflowLink.label) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        )
                      }),
                      _vm.showStandaloneError
                        ? _c(
                            "p",
                            {
                              staticClass: "wkb-assistant-error",
                              attrs: { role: "alert" },
                            },
                            [_vm._v(_vm._s(_vm.error))]
                          )
                        : _vm._e(),
                      _vm.clarification && _vm.clarification.message
                        ? _c(
                            "div",
                            {
                              staticClass: "wkb-assistant-clarify",
                              attrs: { role: "status" },
                            },
                            [
                              _c(
                                "p",
                                { staticClass: "wkb-assistant-clarify-lead" },
                                [_vm._v(" A quick check so I get this right: ")]
                              ),
                              _c(
                                "p",
                                {
                                  staticClass: "wkb-assistant-clarify-message",
                                },
                                [_vm._v(_vm._s(_vm.clarification.message))]
                              ),
                              _vm.clarification.options &&
                              _vm.clarification.options.length
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "wkb-assistant-clarify-options",
                                    },
                                    _vm._l(
                                      _vm.clarification.options,
                                      function (option, index) {
                                        return _c(
                                          "button",
                                          {
                                            key: `clarify-option-${index}`,
                                            staticClass:
                                              "wkb-assistant-clarify-option",
                                            attrs: {
                                              type: "button",
                                              disabled:
                                                _vm.planning || _vm.executing,
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.onClarifyOption(
                                                  option
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " + _vm._s(option.label) + " "
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  )
                                : _vm._e(),
                              _vm.clarification.issues &&
                              _vm.clarification.issues.length
                                ? _c(
                                    "ul",
                                    {
                                      staticClass: "wkb-assistant-clarify-list",
                                    },
                                    _vm._l(
                                      _vm.clarification.issues,
                                      function (issue, index) {
                                        return _c(
                                          "li",
                                          { key: `issue-${index}` },
                                          [_vm._v(" " + _vm._s(issue) + " ")]
                                        )
                                      }
                                    ),
                                    0
                                  )
                                : _vm._e(),
                              _vm.clarification.suggestions &&
                              _vm.clarification.suggestions.length
                                ? _c(
                                    "ul",
                                    {
                                      staticClass:
                                        "wkb-assistant-clarify-suggestions",
                                    },
                                    _vm._l(
                                      _vm.clarification.suggestions,
                                      function (suggestion, index) {
                                        return _c(
                                          "li",
                                          { key: `suggestion-${index}` },
                                          [
                                            _vm._v(
                                              " " + _vm._s(suggestion) + " "
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  )
                                : _vm._e(),
                              _vm.clarification.workflowLink
                                ? _c(
                                    "p",
                                    {
                                      staticClass: "wkb-assistant-workflow-cta",
                                    },
                                    [
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "wkb-assistant-workflow-link",
                                          attrs: {
                                            href: _vm.clarification.workflowLink
                                              .href,
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " Open " +
                                              _vm._s(
                                                _vm.clarification.workflowLink
                                                  .label
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          )
                        : _vm._e(),
                      _vm.plan && _vm.plan.steps.length && !_vm.plan.autoExecute
                        ? _c(
                            "div",
                            { staticClass: "wkb-assistant-plan" },
                            [
                              _vm.plan.panelShortcuts?.overflowNote
                                ? _c(
                                    "p",
                                    {
                                      staticClass:
                                        "wkb-assistant-overflow-note",
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.plan.panelShortcuts.overflowNote
                                          ) +
                                          " "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.plan.panelShortcuts
                                ? [
                                    _c(
                                      "button",
                                      {
                                        ref: "executeAllButton",
                                        staticClass:
                                          "wkb-assistant-execute-all",
                                        attrs: {
                                          type: "button",
                                          disabled: !_vm.canExecuteAll,
                                        },
                                        on: {
                                          click: _vm.onExecuteAll,
                                          keydown: function ($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              _vm._k(
                                                $event.keyCode,
                                                "enter",
                                                13,
                                                $event.key,
                                                "Enter"
                                              )
                                            )
                                              return null
                                            $event.preventDefault()
                                            return _vm.onExecuteAll.apply(
                                              null,
                                              arguments
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.plan.panelShortcuts
                                                .executeLabel
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "ol",
                                      { staticClass: "wkb-assistant-steps" },
                                      _vm._l(
                                        _vm.plan.steps,
                                        function (step, index) {
                                          return _c(
                                            "li",
                                            {
                                              key: step.id,
                                              staticClass: "wkb-assistant-step",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "wkb-assistant-step-main",
                                                },
                                                [
                                                  _c("span", {
                                                    staticClass:
                                                      "wkb-assistant-step-status",
                                                    class: `is-${_vm.stepStatus(
                                                      step.id
                                                    )}`,
                                                    attrs: {
                                                      "aria-label":
                                                        _vm.stepStatusLabel(
                                                          step.id
                                                        ),
                                                    },
                                                  }),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "wkb-assistant-step-label",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(index + 1) +
                                                          ". " +
                                                          _vm._s(step.label) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "wkb-assistant-step-run",
                                                  attrs: {
                                                    type: "button",
                                                    disabled:
                                                      _vm.planning ||
                                                      _vm.executing ||
                                                      _vm.stepStatus(
                                                        step.id
                                                      ) === "done",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.$emit(
                                                        "execute-step",
                                                        step.id
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v(" Run ")]
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                      0
                                    ),
                                    _vm.plan.panelShortcuts
                                      ? _c(
                                          "p",
                                          {
                                            staticClass:
                                              "wkb-assistant-other-options-toggle",
                                            attrs: {
                                              role: "button",
                                              tabindex: "0",
                                              "aria-expanded":
                                                _vm.otherOptionsOpen
                                                  ? "true"
                                                  : "false",
                                            },
                                            on: {
                                              click: _vm.toggleOtherOptions,
                                              keydown: [
                                                function ($event) {
                                                  if (
                                                    !$event.type.indexOf(
                                                      "key"
                                                    ) &&
                                                    _vm._k(
                                                      $event.keyCode,
                                                      "enter",
                                                      13,
                                                      $event.key,
                                                      "Enter"
                                                    )
                                                  )
                                                    return null
                                                  $event.preventDefault()
                                                  return _vm.toggleOtherOptions.apply(
                                                    null,
                                                    arguments
                                                  )
                                                },
                                                function ($event) {
                                                  if (
                                                    !$event.type.indexOf(
                                                      "key"
                                                    ) &&
                                                    _vm._k(
                                                      $event.keyCode,
                                                      "space",
                                                      32,
                                                      $event.key,
                                                      [" ", "Spacebar"]
                                                    )
                                                  )
                                                    return null
                                                  $event.preventDefault()
                                                  return _vm.toggleOtherOptions.apply(
                                                    null,
                                                    arguments
                                                  )
                                                },
                                              ],
                                            },
                                          },
                                          [
                                            _c("span", {
                                              staticClass:
                                                "wkb-assistant-other-options-caret",
                                              class: {
                                                "is-open": _vm.otherOptionsOpen,
                                              },
                                              attrs: { "aria-hidden": "true" },
                                            }),
                                            _vm._v(" Other options "),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm.plan.panelShortcuts &&
                                    _vm.otherOptionsOpen
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "wkb-assistant-other-options-body",
                                          },
                                          [
                                            _vm.plan.panelShortcuts.hasOverflow
                                              ? _c(
                                                  "section",
                                                  {
                                                    staticClass:
                                                      "wkb-assistant-choice-section",
                                                  },
                                                  [
                                                    _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "wkb-assistant-choice-note",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.plan
                                                                .panelShortcuts
                                                                .workflowNote
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "a",
                                                      {
                                                        staticClass:
                                                          "wkb-assistant-choice-link",
                                                        attrs: {
                                                          href: _vm.plan
                                                            .panelShortcuts
                                                            .workflowLink.href,
                                                          target: "_blank",
                                                          rel: "noopener noreferrer",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " Open " +
                                                            _vm._s(
                                                              _vm.plan
                                                                .panelShortcuts
                                                                .workflowLink
                                                                .label
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _c(
                                              "section",
                                              {
                                                staticClass:
                                                  "wkb-assistant-choice-section",
                                              },
                                              [
                                                _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "wkb-assistant-choice-note",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.plan
                                                            .panelShortcuts
                                                            .panelNote
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "wkb-assistant-choice-panel",
                                                    attrs: {
                                                      type: "button",
                                                      disabled:
                                                        _vm.planning ||
                                                        _vm.executing,
                                                    },
                                                    on: {
                                                      click:
                                                        _vm.onOpenPlanPanel,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.plan
                                                            .panelShortcuts
                                                            .panelLabel
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                : [
                                    _c(
                                      "button",
                                      {
                                        ref: "executeAllButton",
                                        staticClass:
                                          "wkb-assistant-execute-all",
                                        attrs: {
                                          type: "button",
                                          disabled: !_vm.canExecuteAll,
                                        },
                                        on: {
                                          click: _vm.onExecuteAll,
                                          keydown: function ($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              _vm._k(
                                                $event.keyCode,
                                                "enter",
                                                13,
                                                $event.key,
                                                "Enter"
                                              )
                                            )
                                              return null
                                            $event.preventDefault()
                                            return _vm.onExecuteAll.apply(
                                              null,
                                              arguments
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v(" Execute all ")]
                                    ),
                                    _c(
                                      "ol",
                                      { staticClass: "wkb-assistant-steps" },
                                      _vm._l(
                                        _vm.plan.steps,
                                        function (step, index) {
                                          return _c(
                                            "li",
                                            {
                                              key: step.id,
                                              staticClass: "wkb-assistant-step",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "wkb-assistant-step-main",
                                                },
                                                [
                                                  _c("span", {
                                                    staticClass:
                                                      "wkb-assistant-step-status",
                                                    class: `is-${_vm.stepStatus(
                                                      step.id
                                                    )}`,
                                                    attrs: {
                                                      "aria-label":
                                                        _vm.stepStatusLabel(
                                                          step.id
                                                        ),
                                                    },
                                                  }),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "wkb-assistant-step-label",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(index + 1) +
                                                          ". " +
                                                          _vm._s(step.label) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "wkb-assistant-step-run",
                                                  attrs: {
                                                    type: "button",
                                                    disabled:
                                                      _vm.planning ||
                                                      _vm.executing ||
                                                      _vm.stepStatus(
                                                        step.id
                                                      ) === "done",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.$emit(
                                                        "execute-step",
                                                        step.id
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v(" Run ")]
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                      0
                                    ),
                                  ],
                            ],
                            2
                          )
                        : _vm._e(),
                    ],
                    2
                  ),
            ]
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.activeTab === "actions",
                  expression: "activeTab === 'actions'",
                },
              ],
              staticClass: "wkb-assistant-body wkb-assistant-actions-panel",
              attrs: {
                id: "wkb-assistant-panel-actions",
                role: "tabpanel",
                "aria-labelledby": "wkb-assistant-tab-actions",
              },
            },
            _vm._l(_vm.actionCatalogSections, function (section) {
              return _c(
                "section",
                {
                  key: section.section,
                  staticClass: "wkb-assistant-action-section",
                },
                [
                  _c(
                    "h2",
                    { staticClass: "wkb-assistant-action-section-title" },
                    [_vm._v(_vm._s(section.section))]
                  ),
                  _c(
                    "p",
                    { staticClass: "wkb-assistant-action-section-intro" },
                    [_vm._v(_vm._s(section.intro))]
                  ),
                  _vm._l(section.groups, function (group) {
                    return _c(
                      "section",
                      {
                        key: `${section.section}-${group.group}`,
                        staticClass: "wkb-assistant-action-group",
                      },
                      [
                        _c(
                          "h3",
                          { staticClass: "wkb-assistant-action-group-title" },
                          [_vm._v(_vm._s(group.group))]
                        ),
                        _c(
                          "ul",
                          { staticClass: "wkb-assistant-action-list" },
                          _vm._l(group.actions, function (action) {
                            return _c(
                              "li",
                              {
                                key: action.id,
                                staticClass: "wkb-assistant-action-item",
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "wkb-assistant-action-label" },
                                  [_vm._v(_vm._s(action.label))]
                                ),
                                _c(
                                  "p",
                                  { staticClass: "wkb-assistant-action-desc" },
                                  [_vm._v(_vm._s(action.description))]
                                ),
                                action.examples.length
                                  ? [
                                      _c(
                                        "p",
                                        {
                                          staticClass:
                                            "wkb-assistant-action-examples-label",
                                        },
                                        [_vm._v("Example requests")]
                                      ),
                                      _c(
                                        "ul",
                                        {
                                          staticClass:
                                            "wkb-assistant-action-examples",
                                        },
                                        _vm._l(
                                          action.examples,
                                          function (example, index) {
                                            return _c(
                                              "li",
                                              { key: `${action.id}-${index}` },
                                              [
                                                _vm._v(
                                                  " " + _vm._s(example) + " "
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                        0
                                      ),
                                    ]
                                  : _vm._e(),
                              ],
                              2
                            )
                          }),
                          0
                        ),
                      ]
                    )
                  }),
                ],
                2
              )
            }),
            0
          ),
          _vm.activeTab === "request" && _vm.showExecutionProgress
            ? _c(
                "div",
                {
                  staticClass: "wkb-assistant-execution-progress",
                  attrs: { role: "status", "aria-live": "polite" },
                },
                [
                  _c(
                    "p",
                    { staticClass: "wkb-assistant-execution-progress-label" },
                    [_vm._v(_vm._s(_vm.executionProgressLabel))]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "wkb-assistant-execution-progress-track",
                      attrs: {
                        role: "progressbar",
                        "aria-busy": "true",
                        "aria-label": _vm.executionProgressLabel,
                      },
                    },
                    [
                      _c("span", {
                        staticClass: "wkb-assistant-execution-progress-fill",
                        attrs: { "aria-hidden": "true" },
                      }),
                    ]
                  ),
                ]
              )
            : _vm._e(),
          _vm.activeTab === "request"
            ? _c("footer", { staticClass: "wkb-assistant-footer" }, [
                _c(
                  "label",
                  {
                    staticClass: "wkb-assistant-input-label",
                    attrs: { for: "wkb-assistant-input" },
                  },
                  [_vm._v(" Your request ")]
                ),
                _c("div", { staticClass: "wkb-assistant-input-wrap" }, [
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.draft,
                        expression: "draft",
                      },
                    ],
                    ref: "requestInput",
                    staticClass: "wkb-assistant-input",
                    attrs: {
                      id: "wkb-assistant-input",
                      rows: "3",
                      disabled: _vm.planning || _vm.executing,
                      placeholder: _vm.requestPlaceholder,
                      autocomplete: "off",
                      autocorrect: "off",
                      autocapitalize: "off",
                      spellcheck: "false",
                      "aria-autocomplete": "list",
                      "aria-expanded": _vm.showAutocomplete ? "true" : "false",
                      "aria-controls": "wkb-assistant-suggest",
                    },
                    domProps: { value: _vm.draft },
                    on: {
                      input: [
                        function ($event) {
                          if ($event.target.composing) return
                          _vm.draft = $event.target.value
                        },
                        _vm.onDraftInput,
                      ],
                      keydown: _vm.onDraftKeydown,
                      click: _vm.updateAutocomplete,
                      focus: _vm.updateAutocomplete,
                      blur: _vm.onDraftBlur,
                    },
                  }),
                  _vm._v(" "),
                  _vm.showAutocomplete
                    ? _c("div", { staticClass: "wkb-assistant-suggest-wrap" }, [
                        _vm.showSuggestionPreview
                          ? _c(
                              "div",
                              {
                                staticClass: "wkb-assistant-suggest-preview",
                                attrs: {
                                  role: "status",
                                  "aria-live": "polite",
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "wkb-assistant-suggest-preview-label",
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.previewSuggestionLabel) +
                                        " "
                                    ),
                                  ]
                                ),
                                _vm.previewSuggestionHint
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "wkb-assistant-suggest-preview-hint",
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.previewSuggestionHint) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            )
                          : _vm._e(),
                        _c(
                          "ul",
                          {
                            staticClass: "wkb-assistant-suggest",
                            attrs: {
                              id: "wkb-assistant-suggest",
                              role: "listbox",
                              "aria-label": "Matching actions and graph nodes",
                            },
                          },
                          _vm._l(
                            _vm.autocompleteSuggestions,
                            function (item, index) {
                              return _c(
                                "li",
                                {
                                  key: item.id,
                                  attrs: { role: "presentation" },
                                },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "wkb-assistant-suggest-item",
                                      class: {
                                        "is-active":
                                          index === _vm.suggestHighlight,
                                      },
                                      attrs: {
                                        type: "button",
                                        role: "option",
                                        "aria-selected":
                                          index === _vm.suggestHighlight
                                            ? "true"
                                            : "false",
                                        title: _vm.suggestionFullLabel(item),
                                      },
                                      on: {
                                        mouseenter: function ($event) {
                                          _vm.suggestHoverIndex = index
                                        },
                                        mouseleave: function ($event) {
                                          _vm.suggestHoverIndex = -1
                                        },
                                        mousedown: function ($event) {
                                          $event.preventDefault()
                                          return _vm.selectSuggestion(item)
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "wkb-assistant-suggest-label",
                                        },
                                        [_vm._v(_vm._s(item.label))]
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "wkb-assistant-suggest-hint",
                                          class: {
                                            "wkb-assistant-suggest-hint--action":
                                              item.kind === "action",
                                            "wkb-assistant-suggest-hint--entity":
                                              item.kind === "entity",
                                            "wkb-assistant-suggest-hint--term":
                                              item.kind === "term",
                                            "wkb-assistant-suggest-hint--phrase":
                                              item.kind === "phrase",
                                            "wkb-assistant-suggest-hint--node":
                                              item.kind === "node",
                                          },
                                        },
                                        [_vm._v(" " + _vm._s(item.hint) + " ")]
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            }
                          ),
                          0
                        ),
                      ])
                    : _vm._e(),
                ]),
                _c(
                  "button",
                  {
                    staticClass: "wkb-assistant-send",
                    attrs: {
                      type: "button",
                      disabled:
                        !_vm.draft.trim() || _vm.planning || _vm.executing,
                    },
                    on: { click: _vm.onPlan },
                  },
                  [_vm._v(" " + _vm._s(_vm.submitButtonLabel) + " ")]
                ),
              ])
            : _vm._e(),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }